import { boolean, number, optional, optionalString, string, z, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

/**
 * Server health detail; only super admins receive it from the heartbeat endpoint. It is the public
 * /heartbeat monitoring response (status, version, ENV, commit, built) plus the detailed status the
 * server logs, under the server's own field names.
 */
export const ApiHeartbeatDetailsSchema = zodLess({
  status: z.enum(['ok', 'failing']),
  message: string,
  version: string,
  ENV: string,
  commit: optionalString,
  built: optionalString,
  uptime: number.describe('fraction of heartbeat checks that passed since the process started, 0 to 1'),
  startedAt: number.describe('process start, unix seconds'),
  now: number.describe('when this status was computed, unix seconds'),
  timeSinceLastStart: string,
  secondsSinceLastStart: number,
  canConnectTo: z.record(z.string(), boolean),
  okCount: number,
  failingCount: number,
  lostTimeCount: number,
  totalCount: number,
  failingCounts: z.record(z.string(), number),
  HEARTBEAT_ENABLED: boolean.describe('whether checks run in the background, or only when someone asks for the status'),
  REFRESH_INTERVAL_SECONDS: number,
  heartbeatGptCostsSinceLastStart: z.record(z.string(), number).describe('LLM spend of the heartbeat ping since the process started'),
}, { ref: 'heartbeatDetails' });
export type ApiHeartbeatDetails = ZodLessInfer<typeof ApiHeartbeatDetailsSchema>;

export const ApiHeartbeatSchema = zodLess({
  success: boolean,
  details: optional(ApiHeartbeatDetailsSchema).describe('present only when the caller is a super admin'),
}, { ref: 'heartbeat' });
export type ApiHeartbeat = ZodLessInfer<typeof ApiHeartbeatSchema>;
